import {
  Text,
  Link,
  HStack,
  VStack,
  ListItem,
  UnorderedList,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import { forwardRef } from 'react';

import NextImage from 'shared/NextImage';

import { EMPTY_OBJECT } from 'constants/global';

const AccordionInfo = (
  {
    title = null,
    titleSx = null,
    RenderTitle = null,
    content = null,
    RenderContent = null,
    contentSx = null,
    panelStyle = null,
    containerStyle = null,
    leftIcon = null,
    rightIcon = null,
    rightIconProps = null,
    link = null,
    description = null,
  },
  _,
) => (
  <AccordionItem w="full" border="none" {...containerStyle}>
    {({ isExpanded }) => (
      <>
        <AccordionButton
          w="full"
          flex="1"
          justifyContent="space-between"
          gap="12px"
          p="0"
          _hover={EMPTY_OBJECT}
        >
          <HStack w="full" spacing="12px">
            {leftIcon}

            {title && (
              <Text
                align="start"
                textStyle="h1"
                {...titleSx}
                {...(isExpanded && { noOfLines: 3, wordBreak: 'unset' })}
              >
                {title}
              </Text>
            )}

            {RenderTitle}
          </HStack>

          {rightIcon && (
            <NextImage
              src={rightIcon}
              alt="Стрелочка"
              w="auto"
              h="auto"
              boxSize="24px"
              transform={isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)'}
              transition="transform .2s"
              {...rightIconProps}
            />
          )}
        </AccordionButton>

        <AccordionPanel motionProps={{ unmountOnExit: true }} {...panelStyle}>
          {content && (
            <Text
              dangerouslySetInnerHTML={{ __html: content }}
              mb={link && '20px'}
              {...contentSx}
            />
          )}
          {RenderContent}

          {description && (
            <VStack
              w="full"
              align="start"
              pt="12px"
              gap="12px"
              textStyle="h4"
              fontSize={{ mobile: '12px', laptop: '16px', desktop: '18px' }}
            >
              <Text>{description?.title}</Text>

              <UnorderedList ml={{ mobile: '26px', laptop: '30px', desktop: '32px' }}>
                {description?.list.map((text, i) => (
                  <ListItem key={`text-${i}`}>{text}</ListItem>
                ))}
              </UnorderedList>
            </VStack>
          )}

          {link && (
            <Link
              as={NextLink}
              href={link}
              display="block"
              mb="1px"
              mt="20px"
              textStyle="button.secondary"
              textAlign="end"
            >
              Подробнее
            </Link>
          )}
        </AccordionPanel>
      </>
    )}
  </AccordionItem>
);

export default forwardRef(AccordionInfo);
